import axios from 'axios';
import authHeader from 'services/API/Auth/AuthHeader';
import AuthService from 'services/API/Auth/AuthService.js';
import authHeaderMultipart from '../Auth/AuthHeaderMultipart';
import { SignalCellularNullSharp } from '@mui/icons-material';


const getMyInviti=(idRichiesta,tipo)=>{

return axios.get(axios.defaults.baseURL + `/ticket/my_inviti/${idRichiesta}/${tipo}`, { headers: authHeader() });
 

}


const aggiungi_inviti = (data_list) => {   
    return axios.post(axios.defaults.baseURL + '/ticket/invito_ins',data_list, {
        headers: authHeader()
    })  
   };

   const elimina_invito = (idInvito) => {   
    return axios.post(axios.defaults.baseURL + `/ticket/invito_del/${idInvito}`,null, {
        headers: authHeader()
    })  
   };

   const invia_invito = (idInvito) => {   
    return axios.post(axios.defaults.baseURL + `/ticket/invito_send/${idInvito}`,null, {
        headers: authHeader()
    })  
   };


  const invia_inviti = (datas) => {
  //  console.log(datas);
         return axios.post(axios.defaults.baseURL + '/ticket/inviti_send',datas, {headers: authHeader()
   })  
  };


      const stampa_invito = (idInvito) => {   
              const response = axios.get(axios.defaults.baseURL + `/ticket/invito_print/${idInvito}`, { headers: authHeader() }, { responseType: 'blob' },);

  return response;
   };


    const stampa_inviti = (datas) => {
  //  console.log(datas);
         return axios.post(axios.defaults.baseURL + '/ticket/inviti_print',datas, {headers: authHeader()
   })  
  };
const InvitiService = {

    getMyInviti,aggiungi_inviti,elimina_invito,invia_invito,invia_inviti, stampa_invito,stampa_inviti,

}

export default InvitiService;